import { Typography, makeStyles } from "@material-ui/core";
import * as React from "react";
import { IParticipant } from "src/common/types";
import { getFullName } from "src/helpers";
import { IAdminRoletItem } from "src/modules/Dashboard/AdminRoles/types";

const useStyles = makeStyles({
  container: {
    "&:hover": {
      background: "#f2f2f2"
    },
    background: "#ffffff",
    border: "1px solid #e6e6e6",
    cursor: "pointer" as "pointer",
    display: "block" as "blcok",
    padding: "16px 19px",
    textAlign: "left" as "left",
    width: 530
  },
  name: {
    fontSize: "1.8rem",
    fontWeight: 600,
    lineHeight: "2.4rem"
  },
  title: {
    color: "#707070",
    fontSize: "1.4rem",
    lineHeight: "1.9rem"
  }
});

interface IOwnProps {
  onSelection?: (participant: IParticipant | IAdminRoletItem) => void;
  onRemove?: () => void;
  participant: IParticipant | IAdminRoletItem;
}

const Suggestion = ({ onSelection, participant }: IOwnProps) => {
  const classes = useStyles();
  const { firstName, lastName, middleName, contractTitle, country, team, department, subDepartment, workplace } =
    participant;

  const workplaceDetails = React.useMemo(() => {
    return [department, subDepartment, team, country, workplace].filter(detail => detail).join(", ");
  }, [department, subDepartment, team, country, workplace]);

  const handleSelection = React.useCallback(() => {
    if (onSelection) {
      return onSelection(participant);
    }
  }, [participant, onSelection]);

  return (
    <button
      data-qa-selector="peerSearchSuggestion"
      type="button"
      onClick={handleSelection}
      className={classes.container}
    >
      <Typography className={classes.name} variant="body1">
        <span data-qa-selector="peerSearchSuggestionFullName">{getFullName([firstName, middleName, lastName])}</span>
      </Typography>
      <Typography className={classes.title} variant="body1">
        <span data-qa-selector="peerSearchSuggestionTitle">{contractTitle}</span>
      </Typography>
      <Typography className={classes.title} variant="body1">
        <span data-qa-selector="peerSearchSuggestionWorkplace">{workplaceDetails}</span>
      </Typography>
    </button>
  );
};
export default Suggestion;
